
jQuery( ( $ ) => {

	$( '.membership .checkbox-style' ).click( function() {
		$( '.add-to-basket' ).removeAttr( 'disabled' );
		$( '.add-to-basket' ).removeClass( 'disabled-btn-state' );

	} );


	$( '.membership .card-custom-memberships .collapse-title > input' ).click( function( ) {

		if (  $( this ).closest( '.card-custom' ).find( '.scheme-notes' ).hasClass( 'display-none' ) ) {
			$( this ).closest( '.card-custom' ).find( '.scheme-notes' ).removeClass( 'display-none' );
		} else {
			$( this ).closest( '.card-custom' ).find( '.scheme-notes' ).addClass( 'display-none' );
		}

		$( '.add-to-basket' ).addClass( 'disabled-btn-state' );
		$( 'input[type="radio"].checkbox-style' ).removeProp( 'checked' );
	} );

	$( '.membership .add-to-basket' )
		.click( async function( event ) {
			event.preventDefault();
			const membershipFundId = $( this ).closest( '.card-custom' ).find( 'input[name="radio-group-1"]' ).val();
			const membershipSchemeWrapperClassName = `card-custom-memberships-${membershipFundId}`;
			const response = await addToBasket( membershipSchemeWrapperClassName );
			updateBasketMessage( response.message, membershipFundId );

			if ( response.basket ) {
				$( '.cart-btn .price' ).text( response.basket.total );
				$( '.checkout' ).removeAttr( 'disabled' );
				$( '.checkout' ).removeClass( 'disabled-btn-state' );

				if ( $( this ).hasClass( 'checkout' ) ) {
					window.location.href = $( this ).attr( 'href' );
				}
			}
		} );

	function updateBasketMessage( message, membershipFundId ) {
		$( `.basket-message-${membershipFundId}` ).text( message.text );
		$( `.basket-message-${membershipFundId}` ).attr( 'class', `alert ${message.className} basket-message basket-message-${membershipFundId}` );
	}

	async function addToBasket( membershipSchemeWrapperClassName ) {
		const $links = $( '.link-event a' );
		$( '.basket-message' ).addClass( 'd-none' );
		$links.addClass( 'disabled-btn-state' );

		const selectedMembershipScheme = $( `.${membershipSchemeWrapperClassName}` ).find( 'input[type="radio"].checkbox-style:checked' );

		const formData = new FormData();
		formData.append( 'action', 'add_membership_to_basket' );
		formData.append( 'schemeId', selectedMembershipScheme.val() );

		if ( selectedMembershipScheme.data( 'concession-id' ) ) {
			formData.append( 'concessionId', selectedMembershipScheme.data( 'concession-id' ) );
		}

		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();

		$links.removeClass( 'disabled-btn-state' );
		return response;
	}

	$( '.membership .tier-radio, .membership .tier-radio-concession' ).click( function() {
		$( '.add-to-basket-tier-view' ).removeClass( 'disabled-btn-state' );
	} );

	$( '.membership .tier-container' ).click( function() {
		$( this ).find( 'input[type="radio"]' ).prop( 'checked', true );
		$( '.add-to-basket-tier-view' ).removeClass( 'disabled-btn-state' );
	} );

	$( '.membership .tier-container-mobile' ).click( function() {
		$( this ).find( 'input[type="radio"]' ).prop( 'checked', true );
		$( '.add-to-basket-tier-view' ).removeClass( 'disabled-btn-state' );
	} );


	$( '.membership .add-to-basket-tier-view' )
		.click( async function( event ) {
			event.preventDefault();
			const response = await addToBasketTierView();
			$( '.basket-message' ).text( response.message.text );
			$( '.basket-message' ).attr( 'class', `alert ${response.message.className} basket-message` );
			if ( response.message.className.includes( 'success' ) ) {
				$( '.checkout-tier-view' ).css( 'display','block' );
			}
			updateBasketMessage( response.message );
			if ( response.basket ) {
				$( '.cart-btn .price' ).text( response.basket.total );
				if ( $( this ).hasClass( 'checkout' ) ) {
					window.location.href = $( this ).attr( 'href' );
				}
			}
		} );

	async function addToBasketTierView() {
		const $links = $( '.add-to-basket-tier-view' );
		$links.addClass( 'disabled-btn-state' );
		$( '.basket-message' ).addClass( 'd-none' );
		const selectedTierRadio = $( 'input[type="radio"]:checked' );
		const formData = new FormData();
		formData.append( 'action', 'add_membership_to_basket' );
		formData.append( 'schemeId', selectedTierRadio.val() );
		if ( selectedTierRadio.data( 'concession-id' ) ) {
			formData.append( 'concessionId', selectedTierRadio.data( 'concession-id' ) );
		}
		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();

		return response;
	}

} );
